
import { WorldCountry } from '../types';

export const egyptExpanded: WorldCountry = {
  code: 'EG',
  name: 'Egypt',
  slug: 'egypt',
  population: 104258327,
  topCities: [
    // Ciudades principales existentes
    { name: 'Cairo', slug: 'cairo', population: 20484965 },
    { name: 'Alexandria', slug: 'alexandria', population: 5397000 },
    { name: 'Giza', slug: 'giza', population: 4872000 },
    { name: 'Shubra El Kheima', slug: 'shubra-el-kheima', population: 1165000 },
    { name: 'Port Said', slug: 'port-said', population: 749371 },
    { name: 'Suez', slug: 'suez', population: 740000 },
    { name: 'Luxor', slug: 'luxor', population: 506588 },
    { name: 'Mansoura', slug: 'mansoura', population: 500000 },
    { name: 'El Mahalla El Kubra', slug: 'el-mahalla-el-kubra', population: 462000 },
    { name: 'Tanta', slug: 'tanta', population: 445000 },
    
    // Nuevas ciudades - Expansión Fase 9
    { name: 'Aswan', slug: 'aswan', population: 430000 },
    { name: 'Fayyum', slug: 'fayyum', population: 420000 },
    { name: 'Zagazig', slug: 'zagazig', population: 410000 },
    { name: 'Ismailia', slug: 'ismailia', population: 400000 },
    { name: 'Assiut', slug: 'assiut', population: 390000 },
    { name: 'Damietta', slug: 'damietta', population: 380000 },
    { name: 'Damanhur', slug: 'damanhur', population: 370000 },
    { name: 'Minya', slug: 'minya', population: 360000 },
    { name: 'Beni Suef', slug: 'beni-suef', population: 350000 },
    { name: 'Hurghada', slug: 'hurghada', population: 340000 },
    { name: 'Qena', slug: 'qena', population: 330000 },
    { name: 'Sohag', slug: 'sohag', population: 320000 },
    { name: 'Shibin El Kom', slug: 'shibin-el-kom', population: 310000 },
    { name: '6th of October City', slug: '6th-of-october-city', population: 300000 },
    { name: 'Kafr el-Sheikh', slug: 'kafr-el-sheikh', population: 290000 },
    { name: 'Arish', slug: 'arish', population: 280000 },
    { name: 'Mallawi', slug: 'mallawi', population: 270000 },
    { name: 'Bilbays', slug: 'bilbays', population: 260000 },
    { name: 'Marsa Matruh', slug: 'marsa-matruh', population: 250000 },
    { name: 'Idfu', slug: 'idfu', population: 240000 },
    { name: 'Mit Ghamr', slug: 'mit-ghamr', population: 230000 },
    { name: 'Al Arish', slug: 'al-arish', population: 220000 },
    { name: 'Kafr Dawwar', slug: 'kafr-dawwar', population: 210000 },
    { name: 'Qus', slug: 'qus', population: 200000 },
    { name: 'Kom Ombo', slug: 'kom-ombo', population: 190000 },
    { name: 'Esna', slug: 'esna', population: 180000 },
    { name: 'Armant', slug: 'armant', population: 170000 },
    { name: 'Qift', slug: 'qift', population: 160000 },
    { name: 'Nag Hammadi', slug: 'nag-hammadi', population: 150000 },
    { name: 'Dishna', slug: 'dishna', population: 145000 },
    { name: 'Girga', slug: 'girga', population: 140000 },
    { name: 'Akhmim', slug: 'akhmim', population: 135000 },
    { name: 'Balyana', slug: 'balyana', population: 130000 },
    { name: 'El Kharijah', slug: 'el-kharijah', population: 125000 },
    { name: 'Mut', slug: 'mut', population: 120000 },
    { name: 'Farafra', slug: 'farafra', population: 115000 },
    { name: 'Bahariya', slug: 'bahariya', population: 110000 },
    { name: 'Siwa', slug: 'siwa', population: 105000 },
    { name: 'Mersa Alam', slug: 'mersa-alam', population: 100000 },
    { name: 'Safaga', slug: 'safaga', population: 95000 },
    { name: 'El Gouna', slug: 'el-gouna', population: 90000 },
    { name: 'Soma Bay', slug: 'soma-bay', population: 85000 },
    { name: 'Makadi Bay', slug: 'makadi-bay', population: 80000 },
    { name: 'Sahl Hasheesh', slug: 'sahl-hasheesh', population: 75000 },
    { name: 'El Quseir', slug: 'el-quseir', population: 70000 },
    { name: 'Marsa Alam', slug: 'marsa-alam-2', population: 65000 },
    { name: 'Berenice', slug: 'berenice', population: 60000 },
    { name: 'Halayeb', slug: 'halayeb', population: 55000 },
    { name: 'Abu Ramad', slug: 'abu-ramad', population: 50000 },
    { name: 'Sharm el-Sheikh', slug: 'sharm-el-sheikh', population: 48000 },
    { name: 'Dahab', slug: 'dahab', population: 46000 },
    { name: 'Nuweiba', slug: 'nuweiba', population: 44000 },
    { name: 'Taba', slug: 'taba', population: 42000 },
    { name: 'Saint Catherine', slug: 'saint-catherine', population: 40000 },
    { name: 'Ras Sudr', slug: 'ras-sudr', population: 38000 },
    { name: 'El Tor', slug: 'el-tor', population: 36000 },
    { name: 'Abu Zenima', slug: 'abu-zenima', population: 34000 },
    { name: 'Ras Gharib', slug: 'ras-gharib', population: 32000 },
    { name: 'Zeit Bay', slug: 'zeit-bay', population: 30000 },
    { name: 'Ain Sokhna', slug: 'ain-sokhna', population: 28000 },
    { name: 'Zafarana', slug: 'zafarana', population: 26000 },
    { name: 'Ras Banas', slug: 'ras-banas', population: 24000 },
    { name: 'Wadi Halfa', slug: 'wadi-halfa', population: 22000 },
    { name: 'Abu Simbel', slug: 'abu-simbel', population: 20000 },
    { name: 'Kalabsha', slug: 'kalabsha', population: 19000 },
    { name: 'Dakka', slug: 'dakka', population: 18000 },
    { name: 'Maharraqa', slug: 'maharraqa', population: 17000 },
    { name: 'Dendur', slug: 'dendur', population: 16000 },
    { name: 'Gerf Hussein', slug: 'gerf-hussein', population: 15000 },
    { name: 'Aniba', slug: 'aniba', population: 14000 },
    { name: 'Faras', slug: 'faras', population: 13000 },
    { name: 'Serra', slug: 'serra', population: 12000 },
    { name: 'Buhen', slug: 'buhen', population: 11000 },
    { name: 'Mirgissa', slug: 'mirgissa', population: 10000 },
    { name: 'Dabod', slug: 'dabod', population: 9500 },
    { name: 'Tafa', slug: 'tafa-eg', population: 9000 },
    { name: 'Beit el-Wali', slug: 'beit-el-wali', population: 8500 },
    { name: 'Kertassi', slug: 'kertassi', population: 8000 },
    { name: 'Talmis', slug: 'talmis', population: 7500 },
    { name: 'Qertassi', slug: 'qertassi', population: 7000 },
    { name: 'New Sebua', slug: 'new-sebua', population: 6500 },
    { name: 'Amada', slug: 'amada', population: 6000 },
    { name: 'Derr', slug: 'derr', population: 5500 },
    { name: 'Ibrim', slug: 'ibrim', population: 5000 },
    { name: 'Ballana', slug: 'ballana', population: 4800 },
    { name: 'Qustul', slug: 'qustul', population: 4600 },
    { name: 'Adindan', slug: 'adindan', population: 4400 },
    { name: 'Korosko', slug: 'korosko', population: 4200 },
    { name: 'Shellal', slug: 'shellal', population: 4000 },
    { name: 'Dabke', slug: 'dabke', population: 3800 },
    { name: 'Daraw', slug: 'daraw', population: 3600 },
    { name: 'Nasr el-Nuba', slug: 'nasr-el-nuba', population: 3400 },
    { name: 'New Halfa', slug: 'new-halfa', population: 3200 },
    { name: 'Khashm el-Girba', slug: 'khashm-el-girba', population: 3000 }
  ]
};
